export default {
    allergyDataByKey: {},
    dietDataByKey: {},
}
